import { inject, Service } from '@angular/core';
import { isStrictStringArray } from '@data-access/shared';
import { OKTA_AUTH } from '@okta/okta-angular';

// Same claim ai-irb checks, same token store (same origin); menu gates agree with Jo.
@Service()
export class OktaGroupsService {
  private readonly _oktaAuth = inject(OKTA_AUTH);

  groups(): string[] {
    const claims = this._oktaAuth.tokenManager.getTokensSync().idToken?.claims;
    const groups = claims?.['groups'] ?? claims?.['group'];
    return isStrictStringArray(groups) ? groups : [];
  }
}
